<template>
  <div>
    <div class="tm-sidebar-left scroller uk-dark uk-animation-slide-left-small uk-animation-fast">     
        <a class="back-button uk-link-text" v-on:click="$emit('sidebarClick', '')"><i class="material-icons">arrow_back</i></a>           
        <div class="uk-text-bold header">
            <span>Tiled</span>
        </div> 
        <form>
            <fieldset class="uk-fieldset">                
                <div class="tile-image-parent uk-text-center">
                    <i class="material-icons uk-inline">add_photo_alternate</i>
                    <label for="file-upload2" class="uk-button uk-button-default uk-button-small uk-margin-small uk-margin-small-left"  style="border-radius: 2px;">
                        <input id="file-upload2" type="file" accept="image/*" @change="uploadMarkForTile"/>
                        Add Image                        
                    </label>  
                    <div v-bind:class="['tile-image-parent uk-text-center', {'checkered-small-1': markForTileLightorDark.isDark, 'checkered-small-3': markForTileLightorDark.isLight}]"> 
                        <img v-if="markForTile" class="tile-image-preview" :src="markForTile"/>
                        <div v-else class="tile-image-placeholder"></div>
                    </div>                                        
                </div>   
                <hr>
                <caption>Controls</caption>
                <div class="uk-margin">
                    <div class="uk-grid">
                        <label class="uk-width-expand uk-form-label"><i class="material-icons uk-inline uk-text-top" style="font-size: 22px;">opacity</i> Opacity</label>
                        <label class="uk-form-label uk-padding-remove">{{$parent.patternOpacity}}%</label>
                    </div>
                    <div class="uk-width-auto uk-margin-auto-vertical">
                        <vue-slider v-model="$parent.patternOpacity" :min="0" :max="100" :tooltip="'none'"></vue-slider>
                    </div>
                </div>                 
                <div class="uk-margin uk-text-top">
                    <div class="uk-grid">
                        <label class="uk-width-expand uk-form-label"><i class="material-icons uk-inline uk-text-top" style="font-size: 22px;">photo_size_select_large</i> Image Size:</label>
                        <label class="uk-form-label uk-padding-remove">{{$parent.patternScaleToWidth}}px</label>
                    </div>
                    <div class="uk-width-auto uk-margin-auto-vertical">
                        <vue-slider v-model="$parent.patternScaleToWidth" :min="10" :max="400" :tooltip="'none'"></vue-slider>
                    </div>
                </div>  
                <div class="uk-margin">
                    <div class="uk-grid">
                        <label class="uk-width-expand uk-form-label"><i class="material-icons uk-inline uk-text-top" style="font-size: 22px;">rotate_right</i> Angle:</label>
                        <label class="uk-form-label uk-padding-remove">{{$parent.patternAngle}}px</label>
                    </div>
                    <div class="uk-width-auto uk-margin-auto-vertical">
                        <vue-slider v-model="$parent.patternAngle" :min="0" :max="360" :tooltip="'none'"></vue-slider>
                    </div>
                </div>                 
                <div class="uk-margin">
                    <div class="uk-grid">
                        <label class="uk-width-expand uk-form-label"><i class="material-icons uk-inline uk-text-top" style="font-size: 22px;">fullscreen</i> Padding:</label>
                        <label class="uk-form-label uk-padding-remove">{{$parent.patternPadding}}px</label>
                    </div>
                    <div class="uk-width-auto uk-margin-auto-vertical">
                        <vue-slider v-model="$parent.patternPadding" :min="0" :max="200" :tooltip="'none'"></vue-slider>
                    </div>
                </div>                      
                <div class="uk-margin">
                    <div class="uk-grid">
                        <label class="uk-width-expand uk-form-label"><i class="material-icons uk-inline uk-text-top" style="font-size: 22px;">compare_arrows</i> Offset X:</label>
                        <label class="uk-form-label uk-padding-remove">{{$parent.patternOffsetX}}px</label>
                    </div>
                    <div class="uk-width-auto uk-margin-auto-vertical">
                        <vue-slider v-model="$parent.patternOffsetX" :min="-200" :max="200" :tooltip="'none'"></vue-slider>
                    </div>
                </div> 
                <div class="uk-margin">
                    <div class="uk-grid">
                        <label class="uk-width-expand uk-form-label"><i class="material-icons uk-inline uk-text-top" style="font-size: 22px; transform: rotate(90deg);">compare_arrows</i> Offset Y:</label>
                        <label class="uk-form-label uk-padding-remove">{{$parent.patternOffsetY}}px</label>
                    </div>
                    <div class="uk-width-auto uk-margin-auto-vertical">
                        <vue-slider v-model="$parent.patternOffsetY" :min="-200" :max="200" :tooltip="'none'"></vue-slider>
                    </div>
                </div>                                                                                                     
            </fieldset>
        </form>         
    </div>

  </div>

</template>

<script>
    import FastAverageColor from 'fast-average-color/dist/index.es6';
    
    export default {
        name: 'sidebar-design',
        data() {
            return {
                markForTile: null,
                markForTileLightorDark: {
                    isDark: false,
                    isLight: false,
                }
            }
        },
        methods: {
            uploadMarkForTile: function(event) {
                // Reference to the DOM input element
                var input = event.target;
                if (input.files[0].size/1000000 > 6) {
                    UIkit.modal.alert('<i class="material-icons uk-inline" style="color: #f4c20d; font-size: 48px;">warning</i> ' + input.files[0].name + ' is <b>too large</b> for tiling. <br>Please choose smaller image/logo.')
                    return
                }
                // Ensure that you have a file before attempting to read it
                if (input.files && input.files[0]) {
                    // create a new FileReader to read this image and convert to base64 format
                    var reader = new FileReader();
                    // Define a callback function to run, when FileReader finishes its job
                    reader.onload = (e) => {
                        // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
                        // Read image as base64 
                        this.markForTile = e.target.result;
                        this.$parent.tileImage(this.markForTile);

                        // fast average color needs an _actual_ html image element
                        const markImage = new Image()
                        markImage.src = e.target.result;

                        const fac = new FastAverageColor();
                        const color = fac.getColor(markImage);

                        if (color.isDark) {
                            this.markForTileLightorDark.isDark = true;
                            this.markForTileLightorDark.isLight = false;
                        } else if (color.isLight) {
                            this.markForTileLightorDark.isLight = true;
                            this.markForTileLightorDark.isDark = false;
                        } else {
                            this.markForTileLightorDark.isLight = false;
                            this.markForTileLightorDark.isDark = false;
                        }
                        
                    fac.destroy();

                    }
                    // Start the reader job - read file as a data url (base64 format)
                    reader.readAsDataURL(input.files[0]);
                }
            }
        }
    }
</script>

<style scoped>

    .header {
        border-bottom: 2px solid #ECB126;
        margin-bottom: 10px;
        margin-top: 50px;  
        text-align: left;
        font-size: 18px;
    }

    input[type="file"] {
        display: none;
    }

    .tile-image-parent {
        border: 1px solid lightgray;
        border-radius: 3px;
    }

    .tile-image-preview {
        height: auto;
        width: auto;
    }  

    .tile-image-placeholder {
        height: 160px;
        width: auto;
        margin: 5px 5px 5px 5px;
        border: 2px dashed lightgray;
        background: rgb(250, 250, 250);
    }

    .vc-compact {
        width: 180px !important;
    }

    .padding-small {
        padding: 12px;
    }

    .back-button {
        position: absolute;
        top: 10px;
        left: 10px;
    }

    .border-type {
        background: rgba(224, 224, 224, 0.6);
        border-bottom: 2px solid transparent;
    }

    .border-type:hover {
        background: rgba(224, 224, 224, 0.9);
        border-bottom: 2px solid #EAB126;
    }

    .file-type-active {
        transition: background-color 0.4s ease;
        background-color: rgb(219, 219, 219);
        pointer-events: none;
    }

    .uk-button-white:hover {
        background: white;
        box-shadow: 0 0 0 1px rgba(50,50,93,.1), 0 2px 5px 0 rgba(50,50,93,.1), 0 3px 9px 0 rgba(50,50,93,.08), 0 1px 1.5px 0 rgba(0,0,0,.08), 0 1px 2px 0 rgba(0,0,0,.08); 
    }

    .uk-card-active {
        outline: 2px solid #28a5f5;
    }

    .uk-placeholder {
        border: none;
    }

    .uk-panel .uk-padding-small {
        padding: 8px 10px 8px 10px;
    }

    a {
        text-decoration: none;
    }

    .checkered-small-1 {
        background-color: #eee;
        background-image: linear-gradient(45deg,rgba(0,0,0,.02) 25%,transparent 0,transparent 75%,rgba(0,0,0,.02) 0,rgba(0,0,0,.02)),linear-gradient(45deg,rgba(0,0,0,.02) 25%,transparent 0,transparent 75%,rgba(0,0,0,.02) 0,rgba(0,0,0,.02));
        background-size: 20px 20px;
        background-position: 0 0,10px 10px;
    }

    .checkered-small-3 {
        background-color: rgb(168, 168, 168);
        background-image: linear-gradient(45deg,rgba(1,1,1,.06) 25%,transparent 0,transparent 75%,rgba(1,1,1,.06) 0,rgba(1,1,1,.06)),linear-gradient(45deg,rgba(1,1,1,.06) 25%,transparent 0,transparent 75%,rgba(1,1,1,.06) 0,rgba(1,1,1,.06));
        background-size: 20px 20px;
        background-position: 0 0,10px 10px;
    }

</style>